import { ApiPath } from "./client";
import { IStatus } from "../../types";
import ApiHandler from "./handler";

export default new ApiHandler<IStatus>(ApiPath.STATUS, "statusId");
